(ns minorodata.app.router
  (:require
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.app.model :refer [->app-route]]
   [re-posh.core :as re-posh]
   [reitit.frontend :as rt.front]
   [reitit.frontend.easy :as rt.easy]
   [clojure.string :as str]))


(def routes
  ["/"
   [""
    {:name :home}]

   ["privacy-policy"
    {:name      :privacy-policy
     :baseClass "privacy-policy"
     :title     "Privacy Policy"
     :public    true}]

   ["login-callback" {:name     :login-callback
                      :callback :users.events/login-callback
                      :public   true}]

   ;; tiktok oauth redirects with a trailed slash for some reason
   ["callback.html/" {:name     :oauth-callback
                      :callback :users.events/oauth-callback
                      :public   true}]

   ["login"
    {:name      :login
     :baseClass "login-page"
     :title     "Login"
     :public    true}]

   ["connections"
    {:name     :connections
     :callback :connections/maybe-open-editor-console
     :title    "Connections"}]

   ["sources"
    {:name  :sources
     :title "Sources"}]

   ["extracts"
    [""
     {:name  :extracts
      :title "Extracts"}]
    ["/:source-id"
     {:name  :source-details
      :title "Extracts"}]
    ["/:source-id/:extract-id"
     {:name  :extract-details
      :title "Extracts"}]]

   ["analytics-models"
    [""
     {:name  :analytics-models
      :title "Analytics models"}]
    ["/new/:project-name"
     {:name  :analytics-model-create
      :title "Analytics models"}]
    ["/:instance-id"
     {:name  :analytics-model-instance-details
      :title "Analytics models"}]
    ["/:instance-id/edit"
     {:name  :analytics-model-instance-edit
      :title "Analytics models"}]]

   ["file-ingest"
    {:name  :file-ingest
     :title "File ingest"}]

   ["dependency-graph"
    {:name  :dag
     :title "Pipelines"}]

   ["warehouse-credentials"
    {:name  :warehouse-credentials
     :title "Warehouse credentials"}]

   ["feature-request"
    {:name  :feature-request
     :title "Feature requests"}]

   ["webforms"
    [""
     {:name  :webforms
      :title "Webforms"}]

    ["/:table-name"
     {:name  :webforms-table
      :title "Webform"}]]

   ;; Keeping the url for legacy purposes
   ["sql-console"
    {:name  :sql-console
     :title "SQL console"}]

   ["data-views"
    [""
     {:name  :data-views
      :title "Share data"}]

    ["/:data-view-id"
     {:name  :data-view-details
      :title "Data View"}]]

   ["dynamic-docs"
    [""
     {:name  :dynamic-docs
      :title "Data docs"}]

    ["/:entity-id"
     {:name  :dynamic-docs-details
      :title "Data docs"}]]

   ["warehouse-usage"
    {:name  :warehouse-usage
     :title "Warehouse usage"}]

   ["forbidden"
    {:name            :forbidden
     :sidebar-enabled false
     :title           "Forbidden"}]

   ["log"
    {:name  :log
     :title "Log"}]

   ["admin"
    {:name  :admin
     :title "Client admin"}]

   ["transformations"
    [""
     {:name  :transformations
      :title "Transformations"}]
    ["/new"
     {:name  :new-group-form
      :title "Create new group"}]
    ["/:group-id"
     {:name  :transforms
      :title "Transforms"}]
    ["/:group-id/new"
     {:name  :new-transform-form
      :title "New transform"}]
    ["/:group-id/details"
     {:name  :group-details
      :title "Transforms"}]
    ["/:group-id/:transform-id"
     {:name  :transform-details
      :title "Transforms"}]]

   ["ui"
    {:name  :ui
     :title "ui"}]

   ["tables"
    [""
     {:name  :tables
      :title "Tables"}]
    ["/details"
     {:name  :table-details
      :title "Table details"}]]

   ["summary"
    {:name  :summary
     :title "Summary"}]


   ;; DATA APPS ROUTES
   ["data-apps"
    ["" {:name :data-apps :title "Data apps"}]
    ["/acquisition"
     ["/market-view" {:name :data-apps-acquisition-market-view :title "Market view"}]
     ["/audience-ai" {:name :data-apps-acquisition-audience-ai :title "Audience AI"}]
     ["/spend" {:name :data-apps-acquisition-spend-optimisation :title "Spend optimisation"}]]
    ["/customers"
     ["/customer-view" {:name :data-apps-customers-customer-view :title "Single customer view"}]
     ["/ai-segmentation" {:name :data-apps-customers-ai-segmentation :title "AI segmentation"}]
     ["/churn" {:name :data-apps-customers-churn-prediction :title "Churn prediction"}]]
    ["/agriculture"
     ["/futures" {:name :data-apps-agriculture-futures :title "Futures Open Position"}]
     ["/contracts-overview" {:name :data-apps-agriculture-contracts-overview :title "Contracts Overview"}]
     ["/market-analysis" {:name :data-apps-agriculture-market-analysis :title "Market Analysis & Scenario Planning"}]
     ["/trading-analysis" {:name :data-apps-agriculture-trading-analysis :title "Physicals Trading Analysis"}]]
    ["/products"
     ["/product-view" {:name :data-apps-products-product-view :title "Product view"}]
     ["/demand" {:name :data-apps-products-demand :title "Demand Forecasting"}]
     ["/inventory" {:name :data-apps-products-inventory :title "Inventory management"}]]
    ["/management"
     ["/sales" {:name :data-apps-management-sales :title "Scorecard"}]
     ["/scorecard" {:name :data-apps-management-scorecard :title "Retail sales performance"}]
     ["/hubspot" {:name :data-apps-management-hubspot :title "Hubspot Campaign Analysis"}]]
    ["/workbook" {:name :data-apps-workbook :title "My reports"}]]

   ["transform-queue"
    {:name :transform-queue
     :title "Transform queue"}]

   ["pipeline-editor"
    {:name  :pipeline-editor
     :title "Pipeline Editor"}]

   ["dashboard"
    {:name  :dashboard
     :title "Dashboard"}]

   ["overview"
    {:name  :overview
     :title "Overview"}]

   ["audit-logs"
    {:name  :audit-logs
     :title "Audit logs"}]

   ["404"
    {:name  :not-found
     :title "404 Page Not Found"}]



   ;; ADMIN ROUTES (may not be present in main app bundle at all)
   ["app-admin"
    [""
     {:name :app-admin}]
    ["/create-new-client"
     {:name :app-admin-create-new-client}]
    ["/create-admin-user"
     {:name :app-admin-create-admin-user}]
    ["/reset-password"
     {:name :app-admin-reset-password}]
    ["/manage-connectors"
     {:name :app-admin-manage-connectors}]
    ["/manage-sigma-connections"
     {:name :app-admin-manage-sigma-connections}]
    ["/manage-sigma-details"
     {:name :app-admin-manage-sigma-details}]]])


(def router
  (rt.front/router routes {:conflicts nil}))

(defn route-mode [route-name]
  (if (str/starts-with? (name route-name) "data-apps")
    "data-apps" "app"))

(defn- on-navigate
  "Function to be called when route changes"
  [new-match _]
  (if new-match
    (let [{:keys [data path-params query-params]} new-match
          route (->app-route {:name    (:name data)
                              :params  path-params
                              :query   query-params
                              :options data})
          navbar @(re-posh/subscribe [:app/prop :app/navbar])
          navbar-mode (route-mode (:name data))]

      (when (and @(re-posh/subscribe [:unleash/is-enabled "fe.data-apps"])
                 (not= (:mode navbar) navbar-mode))
        (dispatch [:app.events/update-navbar {:mode navbar-mode}]))

      (dispatch [:app.events/set-page-title (:title data)])
      (dispatch [:app-route/add route])

      (when (:callback data)
        (dispatch [(:callback data)])))

    (dispatch [:app.events/navigate :not-found])))


(defn init-routes!
  "Registers event listeners on HTML5 history"
  []
  (rt.easy/start!
   router
   on-navigate
   {:use-fragment false}))
